import { TagCategories } from '@dfh-corp-sites/ui'

import { ParentProductFragment } from '../../graphql/search'

export const handleProductTagCategoryPriority = (
  tagCategories: ParentProductFragment['tagCategories'],
): TagCategories | undefined => {
  if (tagCategories.includes('New Products')) {
    return 'New'
  } else if (tagCategories.includes('Best Sellers')) {
    return 'Best Sellers'
  }

  return undefined
}
